import { createTheme } from "@material-ui/core";

const theme = createTheme({
    palette: {
        primary:{
            light: '#6178ed',
            main: '#6178ed',
            dark: '#6178ed',
            contrastText: 'white'
        },
        secondary:{
            light: '#9354F9',
            main: '#9354F9',
            dark: '#9354F9',
            contrastText: 'white'
        },
        error:{
            light: 'red',
            main: 'red',
            dark: 'red',
            contrastText: 'white'
        },
        warning: {
            light: 'orange',
            main: 'orange',
            dark: 'orange',
            contrastText: 'white'
        },
        info:{
            light: 'blue',
            main: 'blue',
            dark: 'blue',
            contrastText: 'white'
        },
        success: {
            light: 'green',
            main: 'green',
            dark: 'green',
            contrastText: 'white'
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
        },
    },
})


theme.props = {
    MuiButton: {
        disableElevation: true
    }
}; 

theme.overrides = {
    MuiButton: {
        contained: {
            borderRadius: 16,
            textTransform: 'none',
            color: 'white',
            background: 'linear-gradient(45deg, ' +  theme.palette.primary.main + ' 30%, '+ theme.palette.secondary.main + ' 90%)',
            "&.Mui-disabled":{
                opacity: 0.7
            }
        },
        containedPrimary: {
            '&:hover': { // changes colors for hover state
                backgroundColor: theme.palette.secondary.main,
                color: 'white !important',
            },
        },
        containedSecondary: {
            fontWeight: 700, // makes text bold
        },
        outlined:{
            borderRadius: 16,
            background: 'none',
            color: '#6178ed !important',
            border: '2px solid',
            borderColor: '#6178ed !important'
        },
    },   
    MuiIconButton: {
        disabled: {
            color: '#CCCCCC !important',
        }
    },
}

export default theme;